export class GaI18nConfig {
    // default language for application
    application?: {
        defaultLanguage?: string,
        languages?: string[]
    };
    content?: {
        defaultLanguage?: string;
        requiredLanguages?: string[];
        languages?: string[];
    };

    constructor(options?: GaI18nConfig) {
        // tslint:disable-next-line:no-string-literal
        const browserLanguage = (navigator && (navigator.language || navigator['userLanguage'])) ?? 'en';
        this.application = {
            languages: options?.application?.languages ?? [browserLanguage]
        };
        this.application.defaultLanguage = options?.application?.defaultLanguage ?? browserLanguage;
        this.content = {
            languages: options?.content?.languages ?? [browserLanguage],
            requiredLanguages: options?.content?.requiredLanguages ?? []
        };
        this.content.defaultLanguage = options?.content?.defaultLanguage ??
            (this.content.languages.includes(browserLanguage) ? browserLanguage : 'en');
    }
}

export const defaultGaI18nConfig: GaI18nConfig = new GaI18nConfig({
    application: {
        languages: ['en', 'ru']
    }
});
